import {
  POG_MASSIVE_UPLOAD_SET_ALLOW_UPLOAD,
  POG_MASSIVE_UPLOAD_CLEAR_ALLOW_UPLOAD,
  POG_MASSIVE_UPLOAD_REQUEST_VERIFY,
  POG_MASSIVE_UPLOAD_SET_VERIFY,
  POG_MASSIVE_UPLOAD_CLEAR_VERIFY,
  POG_MASSIVE_UPLOAD_REQUEST_UPLOAD,
  POG_MASSIVE_UPLOAD_SET_UPLOAD,
  POG_MASSIVE_UPLOAD_CLEAR_UPLOAD,
} from '../actions';

function POGMassiveUploadReducer(state = {}, action) {
  const { type } = action;

  switch (type) {
    case POG_MASSIVE_UPLOAD_SET_ALLOW_UPLOAD:
      return {
        ...state,
        isLoading: false,
        allowUpload: action.payload,
      };

    case POG_MASSIVE_UPLOAD_CLEAR_ALLOW_UPLOAD:
      return {
        ...state,
        isLoading: false,
        allowUpload: null,
      };

    case POG_MASSIVE_UPLOAD_REQUEST_VERIFY:
      return {
        ...state,
        isLoading: true,
        verify: null,
      };

    case POG_MASSIVE_UPLOAD_SET_VERIFY:
      return {
        ...state,
        isLoading: false,
        verify: action.payload,
      };

    case POG_MASSIVE_UPLOAD_CLEAR_VERIFY:
      return {
        ...state,
        isLoading: false,
        verify: null,
      };

    case POG_MASSIVE_UPLOAD_REQUEST_UPLOAD:
      return {
        ...state,
        isLoading: true,
        upload: null,
      };

    case POG_MASSIVE_UPLOAD_SET_UPLOAD:
      return {
        ...state,
        isLoading: false,
        upload: action.payload,
      };

    case POG_MASSIVE_UPLOAD_CLEAR_UPLOAD:
      return {
        ...state,
        isLoading: false,
        upload: null,
      };

    default:
      return state;
  }
}

export default POGMassiveUploadReducer;
